import { BehaviorSubject, filter } from 'rxjs';

export const settings = { admin: false, loaded: false };
const settingsSubject$ = new BehaviorSubject(settings);
export const settings$ = settingsSubject$.asObservable().pipe(filter(value => value.loaded));

export function updateSettings(value) {
  Object.assign(settings, value);
  settingsSubject$.next(settings);
}
